'use strict';

exports.__esModule = true;

var _templateObject = _taggedTemplateLiteralLoose(['\n    width: 100%;\n    height: 100%;\n'], ['\n    width: 100%;\n    height: 100%;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n      color: white;\n      text-align: center;\n      padding: 10px;\n      background-color: #04A3DD;\n      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.17);\n      box-sizing: border-box;\n      -moz-box-sizing: border-box;\n'], ['\n      color: white;\n      text-align: center;\n      padding: 10px;\n      background-color: #04A3DD;\n      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.17);\n      box-sizing: border-box;\n      -moz-box-sizing: border-box;\n']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _productTile = require('../ProductTile/productTile');

var _productTile2 = _interopRequireDefault(_productTile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var RewardProductTileStyled = _styledComponents2.default.div(_templateObject);

var RedeemButtonStyled = _styledComponents2.default.div(_templateObject2);

var RedeemButtonTextStyled = _styledComponents2.default.span(_templateObject);

var RewardProductTile = function RewardProductTile(props) {
    var redeemButtonText = props.redeemButtonText;


    return _react2.default.createElement(
        RewardProductTileStyled,
        { className: "RewardProductTileStyled qa-reward-item-container " },
        _react2.default.createElement(_productTile2.default, props),
        _react2.default.createElement(
            RedeemButtonStyled,
            null,
            _react2.default.createElement(
                RedeemButtonTextStyled,
                null,
                redeemButtonText
            )
        )
    );
};

RewardProductTile.propTypes = {
    displayName: _propTypes2.default.string,
    imageUrl: _propTypes2.default.string.isRequired,
    linkUrl: _propTypes2.default.string,
    calories: _propTypes2.default.string,
    class: _propTypes2.default.string,
    ariaLabel: _propTypes2.default.string,
    redeemButtonText: _propTypes2.default.string
};

exports.default = RewardProductTile;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/RewardProductTile/rewardProductTile.js
// module id = 789
// module chunks = 0